import React from 'react';
import { Pressable } from 'react-native-web';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BodyText } from '../../../../ui';
import { IconComponent } from '../../../../ui/Icons/types';
import analytics from '../../../../../modules/analytics';

type ProActionButtonProps = {
  ButtonIconComponent: IconComponent;
  text: string;
  testID?: string;
  onPress: () => void;
};

export const ProActionButton: React.FC<ProActionButtonProps> = ({
  ButtonIconComponent, text, onPress, testID,
}) => {
  const handlePress = () => {
    analytics.track('provider_action_button_click', {
      action: text.toLowerCase(),
    });
    onPress();
  };

  return (
    <Pressable style={{ flex: 1, minWidth: 90 }} onPress={handlePress} testID={testID}>
      <Box
        alignItems="center"
        justifyContent="center"
        flex={1}
      >
        <Box
          width="100%"
          alignItems="center"
          justifyContent="center"
          borderRadius={4}
          paddingX={28}
          paddingY={12}
          color={BrandColor.LightGrey}
        >
          <ButtonIconComponent color={BrandColor.Metal} height={16} width={16} />
        </Box>
        <Box paddingTop={6}>
          <BodyText color={BrandColor.Metal}>{text}</BodyText>
        </Box>
      </Box>

    </Pressable>
  );
};
